import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { dynamicImage } from "../../../../../utils";
import { InvoiceButtons } from "../common/InvoiceButtons";
import InvoiceDateSection from "./InvoiceDateSection";
import InvoiceHead from "./InvoiceHead";
import InvoiceTableHead from "./InvoiceTableHead";
import { ECommerce, Invoice } from "../../../../../constants";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";
import { Image } from "../../../../../coreComponents/Image";

// This component displays the invoice 5, including invoice header, add section, table, amount section, and buttons.
const InvoiceFiveContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Invoice} parent={ECommerce} />
      <Row>
        <Col sm="12">
          <div className="invoice-2 invoice-5">
            <Card>
              <CardBody>
                <Table borderless>
                  <tbody>
                    <InvoiceHead />
                    <InvoiceDateSection />
                    <tr>
                      <td>
                        <InvoiceTableHead />
                      </td>
                    </tr>
                    <tr className="custom-row">
                      <td>
                        <Image src={dynamicImage(`email-template/invoice-3/sign.png`)} alt="sign" />
                        <span className="name">Laurine T. Ebbert</span>
                        <span className="role">( Designer )</span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
      <InvoiceButtons />
    </>
  );
};

export default InvoiceFiveContainer;
